export default "__VITE_ASSET__aa02576a__"